module.exports = __webpack_public_path__ + "female-icon-active.de1c6b3c2a562b98ef18.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/female-icon-active.svg
// module id = ../../../../../src/assets/images/female-icon-active.svg
// module chunks = main